// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import colors from '../../styled-components/palette';
import MatchBetFilter from '../MatchBetFilter';
import MatchBetHotFilterContent from '../MatchBetHotFilterContent';

const MatchBetHotFilterStyles = {
  selectedBorderColor: colors.redwinamax500,
};

const StyledMatchBetFilter = styled(MatchBetFilter)`
  --MatchBetFilter-selectedBorderColor: ${MatchBetHotFilterStyles.selectedBorderColor};
`;

type MatchBetHotFilterProps = {
  className?: string;
  onClick: () => void;
  isSelected: boolean;
  nbHotBets: number;
};

const MatchBetHotFilter = ({ className = '', onClick, isSelected, nbHotBets }: MatchBetHotFilterProps) => {
  return (
    <StyledMatchBetFilter className={className} onClick={onClick} isSelected={isSelected}>
      <MatchBetHotFilterContent nbHotBets={nbHotBets} />
    </StyledMatchBetFilter>
  );
};

export default React.memo<unknown>(MatchBetHotFilter);
